import React, { useCallback } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Handle } from "./Handle";
import { stores } from "../../stores";
import { getPresetParameter } from "../../model";
import { sysex } from "../../utils/midi";
import { DUMP_PRESET_NN_RECALL, SYSEX_COMMANDS } from "../../model/commands";
import { observer } from "mobx-react-lite";

const LoopStatusCircle = ({ filled, color }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" className="inline-block mr-1">
    <circle
      cx="6"
      cy="6"
      r="4"
      stroke={color}
      strokeWidth="1.5"
      fill={filled ? color : "none"}
    />
  </svg>
);

export const SortableItem = observer((props) => {
  const selectPreset = useCallback((number) => {
    stores.state.selectPreset(number);
    stores.midi.send(sysex([...SYSEX_COMMANDS[DUMP_PRESET_NN_RECALL], number]));
  }, []);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging
  } = useSortable({ id: props.id });

  const presetNum = props.presetNumber;
  const isActive = stores.state.activePreset === presetNum;

  const style = {
    transform: props.ctrlKeyPressed ? null : CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    backgroundColor: isActive ? 'yellow' : 'inherit'
  };

  const deviceType = stores.memory.getDeviceType();
  const is8EZ = deviceType === "DPC-8EZ Gen3";
  const loopStatus = stores.memory.getValue(getPresetParameter("LOOP_STATUS"), presetNum);
  const loopStatusBinary = loopStatus.toString(2).padStart(is8EZ ? 4 : 3, '0');
  let loopStatus2Binary = '';
  if (is8EZ) {
    const loopStatus2 = stores.memory.getValue(getPresetParameter("LOOP_STATUS2"), presetNum);
    loopStatus2Binary = loopStatus2.toString(2).padStart(4, '0');
  }

  return (
    <div 
      ref={setNodeRef} 
      className={`preset-selector ${isActive ? 'selected' : ''} ${props.srcElement ? 'src-elem' : ''} ${props.overed ? 'overed' : ''}`}
      onClick={() => selectPreset(presetNum)} 
      style={style} 
      {...attributes}
    >
      <div style={{ color: 'inherit', width: '100%' }}>
        <div className="preset-name" style={{ color: 'inherit', marginBottom: '2px' }}>
          {stores.memory.getText(getPresetParameter("NAME"), presetNum)}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {is8EZ && (
            <div style={{ display: 'flex', marginBottom: '2px' }}>
              {loopStatus2Binary.split('').map((bit, index) => (
                <LoopStatusCircle key={index} filled={bit === '1'} color="#22c55e" />
              ))}
            </div>
          )}
          <div style={{ display: 'flex' }}>
            {loopStatusBinary.split('').reverse().map((bit, index) => (
              <LoopStatusCircle key={index} filled={bit === '1'} color="#3b82f6" />
            ))}
          </div>
        </div>
      </div>
      <div className="handle-wrapper" {...listeners}>
        <Handle />
      </div>
    </div>
  );
});